import {combineEpics} from "redux-observable";
import {
    connectStomp,
    conversationsFetchEpic,
    stompSubscription,
    subscribeToDefault,
    updateSessionEpic
} from "./conversations";
import {authTest, loginEpic, logoutEpic} from "./login";

export const rootEpic = combineEpics(
    conversationsFetchEpic,
    updateSessionEpic,
    loginEpic,
    logoutEpic,
    authTest,
    stompSubscription,
    connectStomp,
    subscribeToDefault,
);


// WEBPACK FOOTER //
// ./src/epics/root.js